import * as swcHelpers from '@swc/helpers';
import '../utils/get-payment-status-label.js';
import { getPrices } from '../utils/get-prices.js';
import { createImageUrl } from '../utils/create-image-url.js';
import { createLineItemId } from '../utils/create-line-item-id.js';
import { getProductA11yLabel } from '../utils/get-product-a11y-label.js';
import { getProductSubtitle } from '../utils/get-product-subtitle.js';
import { getProductTitle } from '../utils/get-product-title.js';
import '@grandvisionhq/utils';

const toBaseLineItem = (orderLineItem, intl, options = {})=>{
    var ref;
    const price = getPrices(orderLineItem);
    return swcHelpers.objectSpread({
        lineItemId: createLineItemId(orderLineItem),
        quantity: `${intl.getLabel('cart.item.quantity')}: ${orderLineItem.quantity}`,
        sku: orderLineItem.product.sku,
        imageUrl: createImageUrl(orderLineItem.product.mainImage, options),
        title: getProductTitle(orderLineItem, intl),
        subtitle: getProductSubtitle(orderLineItem, intl),
        altText: getProductA11yLabel(orderLineItem, intl),
        productType: (ref = orderLineItem.product.currentProduct) === null || ref === void 0 ? void 0 : ref.type
    }, price);
};

export { toBaseLineItem };
//# sourceMappingURL=base-line-item.js.map
